export default "__VITE_ASSET__DTNDGRPE__"